module.exports = __webpack_public_path__ + "media/assets/icons/audit-49ebfb54f3c522d35578ec0a751b4c27.svg";